import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import useChangePage from "../utils/navigation";
import { useProfile } from "../Hooks/UserHooks";
import useInactivityTimeout from "../Hooks/useInactivityTimeout";

const AuthProtected = (props) => {
  const changePage = useChangePage();
  const { userProfile, loading } = useProfile();

  // Activer le timeout d'inactivité de 10 minutes quand l'utilisateur est connecté
  useInactivityTimeout(10);

  /*
    redirect is un-auth access protected routes via url
    */
  useEffect(() => {
    if (!userProfile && loading) {
      changePage("/auth-login", { from: props.location });
    }
  }, [userProfile, loading, changePage, props.location]);

  if (!userProfile && loading) {
    return null;
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license